import React, { useState, Fragment } from "react";
import { Col, Row, Container } from "react-bootstrap";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import classesX from "../Dashboard/dashboard.module.css";
import AdminNavbar from "../navbar/adminNavbar";
import AddSightseeing from "./addSightseeingManagement";
import SightseeingList from "./sightseeingList";
import SightseeingView from "./sightseeingView";

const SightSeeingManagement = (props) => {
  const [active, updateActive] = useState("1");
  const items = [
    { id: "1", type: "Add Sightseeing" },
    { id: "2", type: "Sightseeing List" },
  ];
  const [data, setdata] = useState({});
  console.log(data);

  return (
    <Fragment>
      <AdminNavbar />
      <h1 className={classesX.Heading}>Sightseeing Management</h1>
      <Container fluid style={{ paddingLeft: "10px" }}>
        <Row>
          <Col lg={12} md={12} className={classes.Response2}>
            <div style={{ height: "100%", width: '95%',marginLeft:"2vw" }}>
              <ul className={classes.Ul} style={{ display: 'flex', flexDirection: 'row', listStyle: 'none', padding: 0 ,height:"10vh",}}>
                {items.map((item) => (
                  <li
                    key={item.id}
                    onClick={() => updateActive(item.id)}
                    className={classes.Li}
                    style={{
                      backgroundColor: `${active === item.id ? 'steelblue' : '#585858'}`,
                      textAlign: 'center',
                      margin: '0 1px', // Adjust the margin as needed
                      padding:" 2% 0",
                      color: 'white',
                      cursor: 'pointer',
                      width:"50%",
                      height:"100%"
                  }}
                  >
                    {item.type}
                  </li>
                ))}
                {active === "3" ? (
                  <li
                    onClick={() => updateActive("2")}
                    className={classes.Li}
                    style={{
                      backgroundColor: `${
                        active === "3" ? "steelblue" : "#585858"
                      }`,
                      textAlign: "center",
                    }}
                  >
                    Back
                  </li>
                ) : null}
              </ul>
            </div>
          </Col>
          <Col lg={12} md={12} className={classes.Response}>
            <div style={{ height: "100%",margin:"2vh 9vw" }}>
              {active === "1" ? (
                <AddSightseeing click={() => updateActive("2")} />
              ) : active === "2" ? (
                <SightseeingList
                  mydata={(e) => setdata(e)}
                  click={() => updateActive("3")}
                />
              ) : active === "3" ? (
                <SightseeingView data={data} />
              ) : null}
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default SightSeeingManagement;
